export enum LogType {
    notFilterItem = 0,
    CreateLocation = 1,
    DeleteLocation = 2,
    upsertChemical = 3,
    deactivedChemical = 4,
    riskAssesed = 5,
    newUsers = 6,
    deleteUsers = 7,
    changedRole = 8,
    ActiveSubtanceInLocation = 9,
    DeActiveSubtanceInLocation = 10,
    MoveSubstanceToOtherLocation = 11,
    updateUsessAcess = 12,
    updateAdmin = 13,
    updateOrganization = 14,
    addSubstanceFromTo = 15,
    report = 16,
    export = 17,
    AddSubstanceToLocation = 18,
    AddSubstanceFromGlobalToOrg = 19,
    accessDepartmentIntoLocation = 20,
    accessLocationIntoDepartment = 21,
    hiddenLocationIntoDepartment = 22,
    hiddenUserInLocationAndChemical = 23,
    hiddenUserGroupInLocationAndChemical = 24,
    hiddenLocationInUserAndUserGroup = 25,
    hiddenChemicalInUserAndUserGroup = 26,
    uploadChemical = 27,
    approveChemical = 28,
    addChemicalToCategory = 29,
    removeCategory = 30,
    UpdateLocation = 31,
    RestoreLocation = 32,
    Mark_UnMarkAsExpiredSubstanceInLocation = 34,
    DeleteSubstanceInLocation = 35,
    ArchiveSubstanceInLocation = 36,
    SubstanceUpdateQuantity = 37,
    SubstanceUpgradedVersion = 38,
    RestoreArchiveSubstanceInLocation = 39,
    removeDraft = 40,
    addCategory = 41,
    removeChemicalInCategory = 42,
    restoreChemical = 43,
    createDepartment = 44,
    updateDepartment = 45,
    deleteDepartment = 46,
    createRole = 47,
    updateRole = 48,
    deleteRole = 49,
    adminRenameOrganization = 50,
    updateCategory = 51,
    userAccessLocation = 52,
    departmentAccessLocation = 53,
    roleAccressLocation = 54,
    hideLocationFromUser = 55,
    hideChemicalFromUser = 56,
    hideLocationFromRole = 57,
    hideChemicalFromRole = 58,
    updateAddressCompany = 59,
    updateUsers = 60,
    changeDepartment = 61,
    changePermissionOnRole = 62,
    RegisterSimpleExposure = 63,
    AddWorkAssignment = 64,
    EditWorkAssignment = 65,
    AddResponsibleToWorkAssignment = 66,
    RestoreSubstitutedSubstanceInLocation = 67,
    CopyRiskAssessment = 68,
    ChangeStatusRiskMeasure = 69
}